<template>
  <div class="loginForm">
    <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
      <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
        注册
      </span>
      <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
        <a href="javascript:;" @click="close">
          <i class="el-icon-close"></i>
        </a>
      </span>
    </div>
    <div style="width: 300px;margin: 0 auto;">
      <el-form :model="registerForm" ref="registerForm" :rules="registers" style="margin-top: 30px;">
        <el-form-item prop="username1">
          <el-input type="text" v-model="registerForm.username1" placeholder="用户名">
            <template slot="prepend"><i class="el-icon-user" style="font-size: 20px; color: #000000;"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input type="text" v-model="registerForm.name" placeholder="昵称">
            <template slot="prepend"><i class="el-icon-s-custom" style="font-size: 20px; color: #000000;"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password1">
          <el-input type="text" v-model="registerForm.password1" placeholder="密码" show-password>
            <template slot="prepend"><i class="el-icon-lock" style="font-size: 20px;color: #000000;"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item prop="repassword1">
          <el-input type="text" v-model="registerForm.repassword1" placeholder="确认密码" show-password>
            <template slot="prepend"><i class="el-icon-lock" style="font-size: 20px;color: #000000;"></i></template>
          </el-input>
        </el-form-item>
        <!--邮箱-->
        <el-form-item prop="email">
          <el-input type="text" v-model="registerForm.email" placeholder="邮箱" :disabled="registerForm.emailinput">
            <template slot="prepend"><i class="el-icon-message" style="font-size: 20px; color: #000000;"></i></template>
            <el-button slot="append" size="mini" @click="getEmailCode" :disabled="button_tof">{{content}}</el-button>
          </el-input>
        </el-form-item>
        <!--邮箱验证-->
        <el-form-item prop="emailcode">
          <el-input type="text" v-model="registerForm.emailcode" placeholder="邮箱验证码" @keyup.enter.native="clickRegister">
            <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px; color: #000000;"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width: 300px;" @click="clickRegister">注&nbsp;&nbsp;&nbsp;册</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 50px;background-color: #f7f7f7;">
      <span style="float: left;margin-left: 20px;line-height: 50px;font-size: 14px;">
        <a href="javascript:;" style="color: #6b91eb;" @click="relogin">返回登录</a>
      </span>
    </div>
    
    <div style="text-align: left;">
      <xieyiCheck ref="childxieyiCheck" @Father_updateChcke="update_check"></xieyiCheck>
    </div>
    
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import {codeAPI} from '@/api/codeAPI'
  import xieyiCheck from '@/components/LoginPage/xieyiCheck.vue'//是否确认协议
export default {
    components: {
      'xieyiCheck': xieyiCheck,
    },
  data () {
    //注册
    var Name = (register, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输如昵称'))
      }else {
        callback()
      }
    }
    var Password1 = (register, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    var Username1 = (register, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    var RePassword1 = (register, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.registerForm.password1) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    var Email = (register, value, callback) => {
      var reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (value === '') {
        callback(new Error('请正确填写邮箱'));
      } else if(!reg.test(value)){
        callback(new Error('请输入有效的邮箱'));
      }else{
        callback();
      }
    }
    var EmailCode = (register, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请输入邮箱验证码'))
      }else if (this.$md5(value.toUpperCase()+"emailcode") !== this.getemailcode) {
        return callback(new Error('邮箱验证码不正确'))
      }else {
        callback()
      }
    }
    return {
      checked:false,//协议确认，
      //用户密码前端salt
      usersalt:'havetorich',
      //用户相关信息
      UserInfor:{
        photo:'',
        name:'',
        id:'',
        token:'',
      },
      loading: false,   //登陆加载效果
      //页面定位
      activeIndex: this.$route.path,
      //注册信息
      registerForm:{
        username1:'',
        name:'',
        password1:'',
        repassword1:'',
        email:'',
        emailcode:'',
        emailinput:false,
      },
      registers:{
        username1: [{
          required: true,
          trigger: 'blur',
          validator: Username1
        }],
        password1: [{
          required: true,
          trigger: 'blur',
          validator: Password1
        }],
        name: [{
          required: true,
          trigger: 'blur',
          validator: Name
        }],
        repassword1: [{
          required: true,
          trigger: 'blur',
          validator: RePassword1
        }],
        email: [{
          required: true,
          trigger: 'blur',
          validator: Email
        }],
        emailcode: [{
          required: true,
          trigger: 'blur',
          validator: EmailCode
        }],
      },
      //计时器
      content: '获取',
      totalTime: 60,
      canClick: true ,//添加canClick
      button_tof:false,
      //传回来的验证码
      getemailcode:'',
      getemail:'',
      //登录验证码
      logincode:{
        logincode:'',
        img:''
      },
    }
  },
  //页面开启时执行
  mounted(){},
  //方法
  methods: {
    //确认协议
    update_check(){
      this.checked=true;
    },
    //登录调用
    login_reginster_ok(){
      this.$refs.childxieyiCheck.handleOpen();
    },
    //进行会话存储
    setlocalStorage(key,value,time){
      let data={ value: value, expirse: new Date(time).getTime() };
      window.localStorage.setItem(key,JSON.stringify(data))
    },
    getlocalStorage(key){
      let data = JSON.parse(window.localStorage.getItem(key));
      if (data!=null||data!='') {
          if (data.expirse != null && data.expirse < new Date().getTime()) {
              window.localStorage.removeItem(key);
          } else {
              return data.value;
          }
          return null;
      }
    },
    //!会话存储结束
    //获取登录验证码方法
    getlogincode(){
      commonAPI('getLoginCodes', this.logincode).then(res => {
        let data=res.data
        this.logincode.logincode=data
        codeAPI('getLoginCode', this.logincode).then(res => {
          let url = window.URL.createObjectURL(res.data);
          this.logincode.img=url
          //console.log(url)
        })
      })
    },
    //登录信息的存储
    saveLogining(){
      sessionStorage.removeItem("store");
      sessionStorage.removeItem("token");//口令
      if(this.$store.state.u_id.length<=0){//只执行一次
        this.$store.commit({
          type:'changeUserInfor',
          u_token:this.UserInfor.token,
          u_id:this.UserInfor.id,
        });
      }else{
        this.$store.commit({
          type:'changeName_Photo',
          name:this.UserInfor.name,
          photo:this.UserInfor.photo
        });
      }
      sessionStorage.setItem("token",this.$store.state.u_token)//口令
      sessionStorage.setItem("store",JSON.stringify(this.$store.state))
      //持久会话的存储
      window.localStorage.removeItem("store");
      window.localStorage.removeItem("token");
      let date = new Date().getTime();
      let daytime=86400000;//一天的时间，时间戳大小
      this.setlocalStorage("store",this.$store.state,date+daytime);//存储用户信息
      this.setlocalStorage("token",this.$store.state.u_token);//存储token
    },

    //登录注册窗口相关
    close(){
      document.getElementById('ptlogin1').style.display='block';
      document.getElementById('other').style.display='none';
      document.getElementById('ptlogin').style.display='block';
      document.getElementById('phonelogin').style.display='none';
      document.getElementById('loginmain').style.display='none';
      document.getElementById('zhedang').style.display='none';
      document.getElementById('registermain').style.display='none';
      document.getElementById('passwordMain').style.display='none';
    },
    openregister(){
      let u_id=this.UserInfor.id;
      if(u_id!=""){
        this.$notify({
        title: '提示',
        message: '你已经登录',
        position: 'bottom-right',
        type: 'success'
        });
      }else{
        document.getElementById('loginmain').style.display='none';
        document.getElementById('registermain').style.display='block';
        document.getElementById('zhedang').style.display='block';
      }
    },
    relogin(){//返回登录
      let u_id=this.UserInfor.id;
      if(u_id!=""){
        this.$notify({
        title: '提示',
        message: '你已经登录',
        position: 'bottom-right',
        type: 'success'
        });
      }else{
        document.getElementById('loginmain').style.display='block';
        document.getElementById('registermain').style.display='none';
      }
    },
    //找回密码——跳转新页面
    openrepass(){
      let i=1;
    },

    //注册方法
    clickRegister(){
      //协议区域
      if(!this.checked){
        this.login_reginster_ok();
        return false;
      }
      //！
      this.$refs.registerForm.validate(valid => {
        if (valid) {//校验成功
          this.loading = true
          setTimeout(() => {//为了看到登录转圈圈的加载效果，这里来一个延迟2秒发送请求
            //封装的公共请求API this.getemail
            if(this.registerForm.email!=this.getemail){
              this.$notify({
              title: '注册提示',
              message: '与获取验证码邮箱不一致',
              position: 'bottom-right',
              type: 'error'
              });
              this.loading = false;
              return false;
            }
            //加盐加密
            let pass=this.registerForm.password1;
            this.registerForm.password1=this.$md5(this.registerForm.password1+this.usersalt);
            this.registerForm.repassword1=this.registerForm.password1;
            commonAPI('AddUser', this.registerForm).then(res => {
            let data = res.data;
            let datas = "";
            if(this.response.response_register(data)){
              data.data.split("\n")
              sessionStorage.removeItem("store");
              sessionStorage.removeItem("token");//口令

              this.UserInfor.id=datas[1];
              this.UserInfor.token=datas[2];
              this.saveLogining();
              this.loading = false;
              setTimeout(() => {
                this.$router.go(0);
              },500)
            }else{
              this.registerForm.password1=pass;
              this.registerForm.repassword1=pass;
              this.loading = false;
            }
            }).catch(error=>{
              this.registerForm.password1=pass;
              this.registerForm.repassword1=pass;
              this.loading = false;
              this.$notify({//这里采用element ui的一个错误显示效果模板
                title: '注册提示',
                message: error.message,
                position: 'bottom-right',
                type: 'error'
              });
            })
            }, 1000);
        }else{
          return false;
        }
      })
    },
    //倒计时
    countDown () {
     if (!this.canClick) return  //改动的是这两行代码
     this.button_tof = true
     this.canClick = false
     this.content = this.totalTime
     let clock = window.setInterval(() => {
      this.totalTime--
      this.content = this.totalTime
      if (this.totalTime <= 0) {
       window.clearInterval(clock)
       this.content = '获取'
       this.totalTime = 60
       this.canClick = true  //这里重新开启
       this.button_tof = false
       this.registerForm.emailinput = false;
      }
     },1000)
    },
    //获取邮箱验证码
    getEmailCode(){
      if(this.registerForm.email==""){
        this.$notify({
        title: '提示',
        message: '请输入邮箱号',
        position: 'bottom-right',
        type: 'error'
        });
        return false;
      }
      var reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if(!reg.test(this.registerForm.email)){
        this.$notify({
        title: '提示',
        message: '邮箱号不正确',
        position: 'bottom-right',
        type: 'error'
        });
        return false;
      }
      this.countDown();
      this.registerForm.emailinput = true;
      this.getemail=this.registerForm.email;
      commonAPI('getEmailCode', this.registerForm).then(res => {
        this.getemailcode=res.data.data;
      })
      //5分钟后销毁当前验证码
      setTimeout(() => {
        this.getemailcode="";
      },300000)
    },

  }
}
</script>

<style scoped>
  /**注册框架*/
  .registerdiv{
    position: fixed;
    top: 15%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display:none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginPage/loginpage_register.vue